var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrivilegeSets = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.9992 1.5C12.2739 1.49971 12.5269 1.64966 12.6584 1.89086L16.8465 9.56905L22.2367 7.54775C22.5018 7.44831 22.8004 7.50672 23.0086 7.69877C23.2167 7.89081 23.2989 8.18373 23.2211 8.45604L20.2211 18.956C20.1291 19.278 19.8349 19.5 19.5 19.5H4.50001C4.16515 19.5 3.87086 19.278 3.77887 18.956L0.778851 8.45604C0.70082 8.18294 0.783762 7.88918 0.993106 7.69722C1.20245 7.50526 1.50227 7.44802 1.76761 7.54937L7.15408 9.60682L11.3408 1.89226C11.4719 1.65078 11.7245 1.50029 11.9992 1.5ZM12.0017 3.8193L8.15917 10.8995C7.97985 11.23 7.58358 11.3766 7.23238 11.2424L2.63305 9.48564L5.06574 18H18.9343L21.3701 9.47473L16.7633 11.2022C16.4135 11.3334 16.0205 11.1871 15.8416 10.8591L12.0017 3.8193ZM3.74999 21.75C3.74999 21.3358 4.08578 21 4.49999 21H19.5C19.9142 21 20.25 21.3358 20.25 21.75C20.25 22.1642 19.9142 22.5 19.5 22.5H4.49999C4.08578 22.5 3.74999 22.1642 3.74999 21.75Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrivilegeSets);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/privilege-sets.c5e1ecc57b5266a1ce4b5bbcb33d6dfd.svg";